/*
 * Public API Surface of angular-resize-element
 */

export * from './lib/angular-resize-element.directive';
export * from './lib/angular-resize-element.module';
export * from './lib/angular-resize-element-event.interface';
export * from './lib/angular-resize-element.enum';
